import { commonApis } from '@/configs/apis/common';
import { isDebug } from '@/scripts/utils/devUtils';
import { FileTransferService } from '@/../submodules/file-transfer-build/js/dist';

export * from '@/../submodules/file-transfer-build/js/dist';

export let fileTransferService: FileTransferService;

export function initFileTransferService() {
  fileTransferService = FileTransferService.createWithTokenProvider(
    {
      serverUrl: import.meta.env.VITE_FILE_SDK_SERVER,
      debug: isDebug,
    },
    async () => {
      return commonApis.getFileSDKToken();
    }
  );
}
